import submit from "submit-form";

// Every modal in this app opens the same way: a GET "refresh" that sets
// `modal[type]` (plus whatever extra query params that modal type reads) -
// profile.controller.js (and its equivalents elsewhere) picks the matching
// component from that value. Centralized so callers don't each re-type the
// same submit() call.
export const openModal = (type, extraParams = {}) =>
  submit("/actions/refresh?", {
    method: "GET",
    body: { "modal[type]": type, ...extraParams },
  });

// The one modal[type] every goal-creation entry point in the app opens
// (DailyGoals.js, ClientGoals.js, Periodization's PhaseSummary.js, the
// select-daily-goal-type picker) - always needs a concrete `modalState`
// (see AddGoal.js's VALID_GOAL_TYPES gate, utils/goals-validations.js).
export const openAddGoal = (modalState) =>
  openModal("add-client-goal", { modalState });
